import { Chevron } from '@/components/svg/chevron/chevron'
import s from './clamp-button.module.css'

type Props = {
  isOpen: boolean
  onClick: () => void
  fill?: string
  text?: string
}

export const ClampButton = ({ isOpen, onClick, fill, text }: Props) => {
  return (
    <button
      aria-label="toggle biography"
      className={s.chevronButton}
      onClick={onClick}
    >
      {text}
      <Chevron
        direction={isOpen ? 'up' : 'down'}
        className={s.chevron}
        fill={fill || '#F68A5B'}
        width={16}
      />
    </button>
  )
}
